import FlightPassengers from './FlightPassengers';

export default FlightPassengers;
